module.exports = __webpack_public_path__ + "img/passion.974cc189.png";